/**
 * TitanSox — Bundle Picker Block JS
 *
 * Single unified slot UI:
 *   [#N] [custom colour picker: thumbnail + label + chevron] [size dropdown]
 *
 * Uses mixMatchProducts for all colour options.
 * Cart always submits items:[{id, quantity}] via /cart/add.js.
 */

(function () {
  'use strict';

  // Single document-level close handler for all open colour pickers
  var openPicker = null;
  document.addEventListener('click', function () {
    if (openPicker) { openPicker.__close(); openPicker = null; }
  });

  // ── Product/variant helpers ───────────────────────────────────────────

  function getSizeOptionIndex(product) {
    var idx = product.options.findIndex(function (o) {
      return o.name.toLowerCase() === 'size';
    });
    return idx >= 0 ? idx : 0;
  }

  function populateSizeSelect(select, product) {
    var sizeIdx = getSizeOptionIndex(product);
    var sizeOpt = product.options[sizeIdx];
    if (!sizeOpt) return;
    select.innerHTML = '<option value="" disabled selected>Size</option>';
    sizeOpt.values.forEach(function (val) {
      var available = product.variants.some(function (v) {
        return v.options[sizeIdx] === val && v.available;
      });
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = available ? val : val + ' — Sold out';
      opt.disabled = !available;
      select.appendChild(opt);
    });
  }

  function findVariantBySize(product, sizeVal) {
    var sizeIdx = getSizeOptionIndex(product);
    return product.variants.find(function (v) {
      return v.options[sizeIdx] === sizeVal;
    }) || null;
  }

  function restoreSize(select, prevVal) {
    if (!prevVal) return;
    var match = Array.from(select.options).find(function (o) {
      return o.value === prevVal && !o.disabled;
    });
    if (match) select.value = prevVal;
  }

  // ── Custom colour picker ──────────────────────────────────────────────

  function buildColorPicker(products, slotIndex, onChange, isOptional) {
    var selectedIdx = isOptional ? -1 : 0;

    var wrap = document.createElement('div');
    wrap.className = 'bpb__slot-color';

    // Trigger row (always visible)
    var trigger = document.createElement('div');
    trigger.className = 'bpb__color-trigger';

    var thumb = document.createElement('img');
    thumb.className = 'bpb__slot-color-thumb';
    if (!isOptional && products[0] && products[0].image) {
      thumb.src = products[0].image;
      thumb.alt = products[0].label || products[0].color;
    } else {
      thumb.style.display = 'none';
    }

    var labelSpan = document.createElement('span');
    labelSpan.className = 'bpb__color-label' + (isOptional ? ' is-placeholder' : '');
    labelSpan.textContent = isOptional ? 'Select Sox' : (products[0] ? (products[0].label || products[0].color) : '');

    var chevronSpan = document.createElement('span');
    chevronSpan.className = 'bpb__color-chevron';
    chevronSpan.innerHTML = '<svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>';

    var clearBtn = null;
    if (isOptional) {
      clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.className = 'bpb__color-clear';
      clearBtn.setAttribute('aria-label', 'Remove this pair');
      clearBtn.textContent = '×';
      clearBtn.hidden = true;
      clearBtn.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      clearBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        clearProduct();
        close();
      });
    }

    trigger.appendChild(thumb);
    trigger.appendChild(labelSpan);
    if (clearBtn) trigger.appendChild(clearBtn);
    trigger.appendChild(chevronSpan);
    wrap.appendChild(trigger);

    // Dropdown panel
    var panel = document.createElement('ul');
    panel.className = 'bpb__color-opts';
    panel.hidden = true;

    products.forEach(function (prod, pi) {
      var item = document.createElement('li');
      item.className = 'bpb__color-opt' + (!isOptional && pi === 0 ? ' is-active' : '');
      item.dataset.pi = pi;

      if (prod.image) {
        var optWrap = document.createElement('div');
        optWrap.className = 'bpb__color-opt-thumb-wrap';
        var optThumb = document.createElement('img');
        optThumb.className = 'bpb__color-opt-thumb';
        optThumb.src = prod.image;
        optThumb.alt = prod.label || prod.color;
        optWrap.appendChild(optThumb);
        item.appendChild(optWrap);
      }
      var optText = document.createElement('span');
      optText.textContent = prod.label || prod.color;
      item.appendChild(optText);

      // mousedown prevents blur before click fires
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        pickProduct(pi);
        close();
      });
      panel.appendChild(item);
    });

    wrap.appendChild(panel);

    function open() {
      if (openPicker && openPicker !== wrap) openPicker.__close();
      panel.hidden = false;
      wrap.classList.add('is-open');
      openPicker = wrap;
    }

    function close() {
      panel.hidden = true;
      wrap.classList.remove('is-open');
      if (openPicker === wrap) openPicker = null;
    }

    wrap.__close = close;

    function pickProduct(pi) {
      var wasUnselected = selectedIdx === -1;
      selectedIdx = pi;
      var prod = products[pi];
      if (prod.image) {
        thumb.src = prod.image;
        thumb.alt = prod.label || prod.color;
        thumb.style.display = '';
      } else {
        thumb.style.display = 'none';
      }
      labelSpan.textContent = prod.label || prod.color;
      labelSpan.classList.remove('is-placeholder');
      panel.querySelectorAll('.bpb__color-opt').forEach(function (item) {
        item.classList.toggle('is-active', parseInt(item.dataset.pi, 10) === pi);
      });
      if (clearBtn) clearBtn.hidden = false;
      if (onChange) onChange(pi, prod, wasUnselected);
    }

    function clearProduct() {
      selectedIdx = -1;
      thumb.style.display = 'none';
      labelSpan.textContent = 'Select Sox';
      labelSpan.classList.add('is-placeholder');
      panel.querySelectorAll('.bpb__color-opt').forEach(function (item) {
        item.classList.remove('is-active');
      });
      if (clearBtn) clearBtn.hidden = true;
      if (onChange) onChange(-1, null, false);
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) open(); else close();
    });

    wrap.getValue = function () { return selectedIdx; };
    wrap.setValue = function (pi) { if (pi >= 0 && pi < products.length) pickProduct(pi); };
    return wrap;
  }

  // ── Slot builder ──────────────────────────────────────────────────────

  function buildSlotEl(products, slotIndex, totalQty, isOptional, onSave) {
    var row = document.createElement('div');
    row.className = 'bpb__slot';
    row.dataset.slotIndex = slotIndex;

    // Size select
    var sizeWrap = document.createElement('div');
    sizeWrap.className = 'bpb__slot-size';
    var sizeSel = document.createElement('select');
    sizeSel.className = 'bpb__size-select';
    sizeSel.setAttribute('aria-label', 'Size for pair ' + (slotIndex + 1));
    if (!isOptional && products[0]) populateSizeSelect(sizeSel, products[0]);
    sizeWrap.appendChild(sizeSel);
    if (isOptional) sizeWrap.hidden = true;

    // Colour picker
    var colorPicker = buildColorPicker(products, slotIndex, function (pi, prod, wasUnselected) {
      if (pi === -1) {
        sizeWrap.hidden = true;
        sizeSel.innerHTML = '';
      } else if (isOptional && wasUnselected) {
        populateSizeSelect(sizeSel, prod);
        sizeWrap.hidden = false;
      } else {
        var prev = sizeSel.value;
        populateSizeSelect(sizeSel, prod);
        restoreSize(sizeSel, prev);
      }
      sizeSel.classList.remove('is-invalid');
      if (onSave) onSave();
    }, isOptional);

    // Slot number overlaid on thumbnail top-left
    if (totalQty > 1) {
      var num = document.createElement('span');
      num.className = 'bpb__slot-num';
      num.textContent = '#' + (slotIndex + 1);
      colorPicker.appendChild(num);
    }

    row.appendChild(colorPicker);
    row.appendChild(sizeWrap);

    sizeSel.addEventListener('change', function () {
      sizeSel.classList.remove('is-invalid');
      if (onSave) onSave();
    });
    return row;
  }

  function buildSlots(container, products, qty, optionalExtra, onSave) {
    container.innerHTML = '';
    for (var i = 0; i < qty; i++) {
      container.appendChild(buildSlotEl(products, i, qty, optionalExtra && i > 0, onSave));
    }
    container.hidden = false;
  }

  // ── Cart helpers ──────────────────────────────────────────────────────

  function collectItems(slotsEl, products) {
    var items = [];
    var valid = true;

    slotsEl.querySelectorAll('.bpb__slot').forEach(function (slot) {
      var picker = slot.querySelector('.bpb__slot-color');
      var pi = picker && typeof picker.getValue === 'function' ? picker.getValue() : 0;
      if (pi === -1) return; // optional slot with no product chosen — skip
      var product = products[pi];

      if (!product) { valid = false; return; }

      var sizeSelect = slot.querySelector('.bpb__size-select');
      var sizeVal = sizeSelect ? sizeSelect.value : '';

      if (!sizeVal) {
        if (sizeSelect) sizeSelect.classList.add('is-invalid');
        valid = false;
        return;
      }

      var variant = findVariantBySize(product, sizeVal);
      if (!variant) {
        if (sizeSelect) sizeSelect.classList.add('is-invalid');
        valid = false;
        return;
      }

      var existing = items.find(function (item) { return item.id === variant.id; });
      if (existing) { existing.quantity += 1; }
      else { items.push({ id: variant.id, quantity: 1 }); }
    });

    return valid ? items : null;
  }

  function openCart() {
    ['cart:refresh', 'theme:cart:open', 'cart:open', 'unicorn:cart:open', 'cart-add-button:success'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (e) { /* ignore */ }
    });
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true })); }
      catch (e) { /* ignore */ }
    }).catch(function () { /* ignore */ });
  }

  // ── Init picker ───────────────────────────────────────────────────────

  function initPicker(el) {
    var blockId = el.dataset.blockId;
    var data = window['bpb_' + blockId];
    if (!data) return;

    var optionEls = el.querySelectorAll('[data-bpb-option]');
    var ctaBtn    = el.querySelector('[data-bpb-cta]');
    var ctaLabel  = el.querySelector('[data-bpb-cta-label]');
    var baseLabel = ctaLabel ? ctaLabel.textContent.trim() : 'ADD TO CART';

    function money(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(Math.round(cents));
      var sample = String((data.colorProducts[0] && data.colorProducts[0].variants[0] && data.colorProducts[0].variants[0].price) || '');
      var symbol = '$';
      return symbol + (cents / 100).toFixed(2);
    }

    function productPrice() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] select[name="id"]');
      var id = input && input.value;
      var variant = data.colorProducts[0] && data.colorProducts[0].variants.find(function (v) { return String(v.id) === String(id); });
      return variant || (data.colorProducts[0] && data.colorProducts[0].variants.find(function (v) { return v.available; })) || null;
    }

    function discountPercent(text) {
      var match = String(text || '').match(/(\d+(?:\.\d+)?)\s*%/);
      return match ? parseFloat(match[1]) / 100 : 0;
    }

    function parseMoney(value) {
      var numeric = String(value || '').replace(/[^0-9.,-]/g, '').replace(/,(?=\d{3}(?:\D|$))/g, '');
      numeric = numeric.replace(',', '.');
      var amount = parseFloat(numeric);
      return isNaN(amount) ? 0 : Math.round(amount * 100);
    }

    function tierPricing(opt) {
      if (!data.useProductPrice || opt.dataset.useProductPrice !== 'true') return { now: opt.dataset.price, was: opt.dataset.was, each: opt.dataset.each };
      var variant = productPrice();
      if (!variant && !data.basePrice) return { now: opt.dataset.price, was: opt.dataset.was, each: opt.dataset.each };
      var qty = parseInt(opt.dataset.qty, 10) || 1;
      var productCents = Number(variant ? variant.price : data.basePrice);
      var wasCents = 0;
      var effectiveQty = qty;
      if (opt.dataset.tier === '1') {
        var slots = opt.querySelectorAll('.bpb__slot-color');
        var selectedSlots = 0;
        slots.forEach(function (picker) { if (picker.getValue && picker.getValue() >= 0) selectedSlots += 1; });
        effectiveQty = Math.max(1, selectedSlots);
      }
      var nowCents = productCents * effectiveQty;
      var freeMatch = String(opt.dataset.name || '').match(/\+\s*(\d+)\s*(?:FREE)?/i);
      var billedPairs = qty + (freeMatch ? parseInt(freeMatch[1], 10) : 0);
      if (opt.dataset.tier !== '1') {
        nowCents = productCents * qty;
        billedPairs = qty + (opt.dataset.tier === '2' ? 1 : 2);
        wasCents = productCents * billedPairs;
        var discount = Math.round(((wasCents - nowCents) / wasCents) * 10000) / 100;
        opt.dataset.calculatedDiscount = discount.toFixed(2) + '% Off';
      }
      return {
        now: money(nowCents),
        was: money(wasCents),
        each: opt.dataset.tier === '1' && effectiveQty > 1 ? money(productCents) + '/pair' : (opt.dataset.tier === '1' ? null : money(nowCents / billedPairs) + '/pair')
      };
    }

    function refreshPrices() {
      optionEls.forEach(function (opt) {
        var p = tierPricing(opt);
        var now = opt.querySelector('.bpb__price-now'), was = opt.querySelector('.bpb__price-was'), each = opt.querySelector('.bpb__price-each');
        if (now) now.textContent = p.now;
        if (was) was.textContent = opt.dataset.tier === '1' ? '' : (p.was || '');
        if (each) each.textContent = opt.dataset.tier === '1' ? (p.each ? '(' + p.each + ')' : '(each)') : (p.each ? '(' + p.each + ')' : '');
        var badge = opt.querySelector('.bpb__discount-badge');
        if (badge && opt.dataset.calculatedDiscount) badge.textContent = opt.dataset.calculatedDiscount;
        opt.dataset.currentPrice = p.now;
      });
      var selected = el.querySelector('.bpb__option.is-selected');
      if (selected) updateCta(selected);
    }

    var STORAGE_KEY = 'bpb_state';

    function saveState() {
      var tierIdx = -1;
      optionEls.forEach(function (o, idx) {
        if (o.classList.contains('is-selected')) tierIdx = idx;
      });
      var slots = [];
      var selectedOpt = el.querySelector('.bpb__option.is-selected');
      if (selectedOpt) {
        var slotsEl = selectedOpt.querySelector('[data-bpb-slots]');
        if (slotsEl) {
          slotsEl.querySelectorAll('.bpb__slot').forEach(function (slot) {
            var picker = slot.querySelector('.bpb__slot-color');
            var pi = picker && typeof picker.getValue === 'function' ? picker.getValue() : -1;
            if (pi === -1) { slots.push(null); return; }
            var prod = data.mixMatchProducts[pi];
            var sizeSelect = slot.querySelector('.bpb__size-select');
            slots.push({ handle: prod ? prod.handle : null, size: sizeSelect ? sizeSelect.value : '' });
          });
        }
      }
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ tier: tierIdx, slots: slots })); } catch (e) {}
    }

    function loadState() {
      try { var raw = sessionStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
    }

    function restoreSlots(slotsEl, slotData, products) {
      if (!slotData) return;
      slotsEl.querySelectorAll('.bpb__slot').forEach(function (slot, i) {
        var saved = slotData[i];
        if (!saved || !saved.handle) return;
        var pi = -1;
        for (var j = 0; j < products.length; j++) {
          if (products[j].handle === saved.handle) { pi = j; break; }
        }
        if (pi === -1) return;
        var picker = slot.querySelector('.bpb__slot-color');
        if (picker && picker.setValue) picker.setValue(pi);
        if (saved.size) {
          var sizeSelect = slot.querySelector('.bpb__size-select');
          if (sizeSelect) restoreSize(sizeSelect, saved.size);
        }
      });
    }

    optionEls.forEach(function (opt) {
      opt.querySelector('.bpb__option-row').addEventListener('click', function () {
        selectOption(opt, null);
        saveState();
      });
    });

    function selectOption(opt, slotData) {
      optionEls.forEach(function (o) {
        o.classList.remove('is-selected');
        o.querySelector('.bpb__radio').checked = false;
        var s = o.querySelector('[data-bpb-slots]');
        if (s) s.hidden = true;
      });
      opt.classList.add('is-selected');
      opt.querySelector('.bpb__radio').checked = true;
      renderSlots(opt, slotData);
      updateCta(opt);
    }

    function renderSlots(opt, slotData) {
      var slotsEl = opt.querySelector('[data-bpb-slots]');
      if (!slotsEl) return;
      var qty = parseInt(opt.dataset.qty, 10) || 1;
      var optionalExtra = opt.dataset.optionalSlots === 'true';
      buildSlots(slotsEl, data.mixMatchProducts, qty, optionalExtra, function () {
        saveState();
        refreshPrices();
      });
      if (slotData) restoreSlots(slotsEl, slotData, data.mixMatchProducts);
    }

    function updateCta(opt) {
      if (!ctaLabel) return;
      var price = opt.dataset.currentPrice || tierPricing(opt).now;
      var qty = parseInt(opt.dataset.qty, 10) || 1;
      ctaLabel.textContent = baseLabel + (qty > 1 ? ' · ' + price : ' — ' + price);
    }

    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') refreshPrices(); });
    document.addEventListener('variant:change', refreshPrices);

    var saved = loadState();
    var initTierIdx = saved && saved.tier >= 0 && saved.tier < optionEls.length ? saved.tier : -1;
    var initSlots = saved ? saved.slots : null;

    var preselected = initTierIdx >= 0 ? optionEls[initTierIdx] : el.querySelector('.bpb__option.is-selected');
    if (preselected) { selectOption(preselected, initSlots); updateCta(preselected); }
    else if (optionEls.length > 0) { selectOption(optionEls[0], null); }
    refreshPrices();

    ctaBtn.addEventListener('click', function () {
      if (ctaBtn.disabled || ctaBtn.classList.contains('is-loading')) return;

      var selectedOpt = el.querySelector('.bpb__option.is-selected');
      if (!selectedOpt) { showError('Please select a bundle above.'); return; }

      var slotsEl = selectedOpt.querySelector('[data-bpb-slots]');
      var items = collectItems(slotsEl, data.mixMatchProducts);

      if (!items) { showError('Please select a size for each pair.'); return; }

      setLoading(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return res.json();
      })
      .then(function () { setLoading(false); showSuccess(); openCart(); })
      .catch(function (err) { setLoading(false); showError(err.message || 'Something went wrong.'); console.error('[BundlePickerBlock]', err); });
    });

    function setLoading(on) { ctaBtn.classList.toggle('is-loading', on); ctaBtn.disabled = on; }

    function showSuccess() {
      var orig = ctaLabel ? ctaLabel.textContent : '';
      ctaBtn.classList.add('is-success');
      if (ctaLabel) ctaLabel.textContent = '✓ Added to Cart!';
      setTimeout(function () { ctaBtn.classList.remove('is-success'); ctaBtn.disabled = false; if (ctaLabel) ctaLabel.textContent = orig; }, 2500);
    }

    function showError(msg) {
      var orig = ctaLabel ? ctaLabel.textContent : '';
      ctaBtn.classList.add('is-error');
      if (ctaLabel) ctaLabel.textContent = msg;
      setTimeout(function () { ctaBtn.classList.remove('is-error'); ctaBtn.disabled = false; if (ctaLabel) ctaLabel.textContent = orig; }, 3000);
    }
  }

  function boot() { document.querySelectorAll('[data-bpb]').forEach(initPicker); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bpb]').forEach(initPicker);
  });

})();
